<div class="cre-stat-panel">
  <fa-icon
    *ngIf="showTractorIcon"
    class="cre-stat-panel-icon-transparent cre-tractor-icon" [icon]="iconConfiguration"
  >
  </fa-icon>
  <fa-icon *ngIf="!showTractorIcon" class="cre-stat-panel-icon" [icon]="iconConfiguration">
  </fa-icon>

  <span class="cre-stat-panel-label">{{ label1 }}</span>
  <span class="cre-stat-panel-label">{{ label2 }}</span>
  <div class="cre-stat-panel-divider"></div>
  <span class="cre-stat-panel-value" *ngIf="!isValueBoolean">{{ value }}</span>
  <fa-icon
    class="cre-stat-panel-value"
    [icon]="['fal', 'check']"
    *ngIf="isValueBoolean && value"
  ></fa-icon>
  <fa-icon
    class="cre-stat-panel-value"
    [icon]="['fal', 'times']"
    *ngIf="isValueBoolean && !value"
  ></fa-icon>
</div>
